export const PopupType = Object.freeze({
	userProfile: 'im-user-settings-popup',
	userStatus: 'im-user-status-popup',
	backgroundSelect: 'im-background-select-popup',
	recentContextMenu: 'im-recent-context-menu',
	recentHeaderMenu: 'im-recent-header-menu',
	createChatMenu: 'im-create-chat-menu',
	dialogMessageMenu: 'bx-im-message-context-menu',
	dialogAvatarMenu: 'bx-im-avatar-context-menu',
	dialogReactionUsers: 'bx-im-message-reaction-users',
	dialogReadUsers: 'bx-im-dialog-read-users',
	createChatManageUsersAddMenu: 'im-content-create-chat-manage-users-add',
	createChatManageUsersDeleteMenu: 'im-content-create-chat-manage-users-delete',
	createChatManageUiMenu: 'im-content-create-chat-manage-ui',
	createChatManageMessagesMenu: 'im-content-create-chat-can-post',
	messageBaseFileMenu: 'im-message-base-file-context-menu',
	desktopItemMenu: 'im-navigation-desktop-item-context-menu',
	messageHistoryLimit: 'im-message-history-limit-popup',
	emoteSelector: 'im-emote-selector-popup',
	stickerPack: 'im-sticker-pack-popup',
	stickerContextMenu: 'im-sticker-context-menu',
	stickerPackContextMenu: 'im-sticker-pack-context-menu',
	sharedLinkContextMenu: 'im-shared-link-context-menu',
	mentionAddToChatDropdown: 'im-mention-add-to-chat-dropdown',
});
